import { ComponentErrorBoundary } from '@/components';
import type { EventResponse } from '@/types';
import { capitalizeWords } from '@/utils';
import { MarketCardList } from './MarketCardList';

interface MarketListByTabProps {
  activeCategorySlug?: string;
  events: EventResponse[];
  selectedFilter?: string;
  handleTradeClick: (marketId: string, outcomeId: string, isBuyOrder: boolean) => void;
  isResolvedFilter?: boolean;
}

export const MarketListByTab = ({
  activeCategorySlug,
  selectedFilter,
  events,
  handleTradeClick,
  isResolvedFilter,
}: MarketListByTabProps) => {
  return (
    <ComponentErrorBoundary componentName={capitalizeWords(activeCategorySlug || 'all')}>
      <MarketCardList
        events={events}
        activeCategorySlug={activeCategorySlug}
        selectedFilter={selectedFilter}
        onTradeClick={handleTradeClick}
        isResolvedFilter={isResolvedFilter}
      />
    </ComponentErrorBoundary>
  );
};
